import styled from 'styled-components';

export const SliderBulletsStyled = styled.div<{ $isHidden: boolean }>`
	position: relative;
	display: ${({ $isHidden }) => ($isHidden ? 'none' : 'flex')};
	justify-content: center;
	gap: 16px;
	margin-top: 20px;

	/* stylelint-disable no-unused-selectors */
	.swiper-custom-bullet {
		width: 12px;
		height: 12px;
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%;
		border-radius: 50%;
		background: ${({ theme }) => theme.colors.transparent.light10};

		&-active {
			background: ${({ theme }) => theme.colors.icon.alwaysWhite};
		}
	}

	@media screen and (min-width: 764px) {
		margin-top: 20px;
	}
`;
